import { FC } from 'react'
import { NameDto } from '@/api/Common/Types'
import { CategoryType } from 'api/Documents/Types/ClientDocument'
import { Modal } from 'components/CustomModal'

import { BulkCategoryUpdateForm, BulkUpdateFormValues } from './BulkCategoryUpdateForm'

interface Props {
  clientDocumentTypes: NameDto[]
  clientDocumentCategoryTypes: CategoryType[]
  closeModal: () => void

  onSubmitForm: (values: BulkUpdateFormValues) => void

  getDocumentTypeBasedOnCategory(categoryId: string): void
}
export const BulkCategoryUpdateModal: FC<Props> = ({
  onSubmitForm,
  closeModal,
  clientDocumentCategoryTypes,
  clientDocumentTypes,
  getDocumentTypeBasedOnCategory,
}) => {
  return (
    <Modal visible={true} onClose={closeModal}>
      <BulkCategoryUpdateForm
        clientDocumentCategoryTypes={clientDocumentCategoryTypes}
        clientDocumentTypes={clientDocumentTypes}
        getDocumentTypeBasedOnCategory={getDocumentTypeBasedOnCategory}
        onCloseModal={closeModal}
        onSubmitForm={onSubmitForm}
      />
    </Modal>
  )
}
